import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  InputAdornment,
  Box,
  TextField,
  Button,
} from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { loginPageStyles } from '../../../../styles';
import { verifyCurrentUserPasswordAPI } from '../../../../redux/features/User/api';
import { TailSpin } from 'react-loader-spinner';
import { useSelector } from 'react-redux';

// Button Theme & Styling
const ButtonTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
          '&.Mui-disabled': {
            opacity: 0.7,
          },
        },
      },
    },
  },
});

const dialogButtonStyle = {
  width: '100%',
  textTransform: 'capitalize',
  fontSize: '17px',
  color: '#FFFFFF',
  fontWeight: '700',
  lineHeight: '22px',
  fontFamily: 'Mukta',
  padding: '8px',
};

function CurrentPasswordDialog(props) {
  const [open, setOpen] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [lengthValidation, setLengthValidation] = useState();
  const [validationError, setValidationError] = useState('');
  const [loading, setLoading] = useState(false);
  const classes = loginPageStyles();
  const user = useSelector((state) => state.userReducer.user);

  // Password Field Handlers
  const handleInput = (e) => {
    setCurrentPassword(e.target.value);
  };
  const handleShowPassword = () => {
    setShowPassword((previousValue) => !previousValue);
  };

  // Next Button handler
  const handleNextButton = async () => {
    // call api for verification
    try {
      setLoading(true);
      const payload = {
        id: user.id,
        rider: {
          password: currentPassword,
        },
      };
      const response = await verifyCurrentUserPasswordAPI(payload);
      if (response?.data?.message === 'Authenticated successfully') {
        props.setCurrentPasswordVerified(true);
      } else {
        throw new Error('Current password is not valid.');
      }
    } catch (error) {
      setValidationError(error?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentPassword?.length >= 8) {
      setLengthValidation(true);
    } else {
      setLengthValidation(false);
    }
    if (validationError != '') {
      setValidationError('');
    }
  }, [currentPassword]);

  const handleClose = () => {
    props.setChangePasswordDialog(false);
    setOpen(false);
  };

  return (
    <>
      {' '}
      <Dialog
        sx={{
          '& .MuiDialogContent-root ': {
            padding: '0px 0px',
            margin: 0,
          },
        }}
        margin={0}
        open={open}
        onClose={handleClose}
      >
        <DialogContent>
          <>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              padding="24px"
              maxWidth="350px"
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
                noValidate
              >
                <Box sx={{ marginBottom: '20px' }}>
                  <Box
                    sx={{
                      mb: '2px',
                      display: 'flex',
                      fontWeight: '700',
                      fontSize: '15px',
                      color: '#455066',
                      lineHeight: '20px',
                      fontFamily: 'Mukta',
                      letterSpacing: '0.005em',
                    }}
                  >
                    Enter Current Password
                  </Box>
                  <Box>
                    <TextField
                      size="small"
                      error={validationError !== '' ? true : false}
                      autoComplete="off"
                      helperText={
                        validationError !== '' ? `* ${validationError}` : ''
                      }
                      className={classes.textField}
                      type={showPassword ? 'text' : 'password'}
                      value={currentPassword}
                      name="currentPassword"
                      onChange={handleInput}
                      variant="outlined"
                      placeholder="Current Password"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={handleShowPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <Visibility
                                  sx={{
                                    width: '21px',
                                    color: '#8493AE',
                                  }}
                                />
                              ) : (
                                <VisibilityOff
                                  sx={{
                                    width: '21px',
                                    color: '#8493AE',
                                  }}
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      inputProps={{
                        minLength: 8,
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  width: '100%',
                }}
              >
                <ThemeProvider theme={ButtonTheme}>
                  <Button
                    variant="text"
                    onClick={handleNextButton}
                    style={dialogButtonStyle}
                    disabled={loading ? true : !lengthValidation ? true : false}
                    sx={{
                      width: '100%',
                      borderRadius: '8px',
                      background: '#054E8B',
                      bgcolor: '#054E8B',
                      ':hover': {
                        bgcolor: '#054E8B',
                      },
                      marginRight: '1rem',
                    }}
                  >
                    Next
                    {loading && (
                      <TailSpin
                        height="20"
                        width="20"
                        color="#fff"
                        ariaLabel="tail-spin-loading"
                        radius="1"
                        visible={loading}
                        wrapperStyle={{ marginLeft: '0.5rem' }}
                      />
                    )}
                  </Button>
                </ThemeProvider>
              </Box>
            </Grid>
          </>
        </DialogContent>
      </Dialog>{' '}
    </>
  );
}
CurrentPasswordDialog.propTypes = {
  setSuccessful: PropTypes.func.isRequired,
  setUnsuccessful: PropTypes.func.isRequired,
  user: PropTypes.number.isRequired,
  setChangePasswordDialog: PropTypes.func.isRequired,
  setCurrentPasswordVerified: PropTypes.func.isRequired,
};
export default CurrentPasswordDialog;
